/**
 * HOOK: useSchoolsSelect
 * Hook léger pour charger uniquement les écoles nécessaires aux selects
 *
 * ⚡ Optimisation: Ne charge que id + name
 */

import { useSelectData } from './useSelectData';

interface SchoolSelectItem {
  id: string;
  name: string;
}

interface UseSchoolsSelectReturn {
  schools: SchoolSelectItem[];
  loading: boolean;
  error: Error | null;
  refresh: () => Promise<void>;
}

export function useSchoolsSelect(): UseSchoolsSelectReturn {
  const { data, loading, error, refresh } = useSelectData('schools', 'id, name', 'name', true);

  return {
    schools: data as SchoolSelectItem[],
    loading,
    error,
    refresh,
  };
}
